import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';

const Home: React.FC = () => {
  const [isDragActive, setIsDragActive] = useState(false);
  const navigate = useNavigate();

  const handleDrag = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setIsDragActive(true);
    } else if (e.type === "dragleave") {
      setIsDragActive(false);
    }
  }, []);

  const handleFile = useCallback((file: File) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      if (e.target?.result) {
        localStorage.setItem('uploadedImage', e.target.result as string);
        navigate('/imageview');
      }
    };
    reader.readAsDataURL(file);
  }, [navigate]);

  const handleDrop = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFile(e.dataTransfer.files[0]);
    }
  }, [handleFile]);

  const handleFileInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      handleFile(e.target.files[0]);
    }
  };

  return (
    <div className="home-container">
      <h1 className="main-title">Trace Pixels To Vectors in Full Color</h1>
      <p className="subtitle">Convert your PNG and JPG images to SVG vectors quickly and easily.</p>
      <p className="subtitle">Fully automatically. Using AI.</p>

      <div
        className={`upload-area ${isDragActive ? 'drag-active' : ''}`}
        onDragEnter={handleDrag}
        onDragLeave={handleDrag}
        onDragOver={handleDrag}
        onDrop={handleDrop}
      >
        <div className="file-icons">
          <div className="file-icon">
            <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
              <rect x="10" y="10" width="40" height="40" rx="4" fill="#E8F0FE" stroke="#4285F4" strokeWidth="2"/>
              <text x="30" y="38" fontSize="12" fill="#4285F4" textAnchor="middle" fontWeight="600">.gif</text>
            </svg>
          </div>
          <div className="file-icon">
            <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
              <rect x="10" y="10" width="40" height="40" rx="4" fill="#E8F0FE" stroke="#4285F4" strokeWidth="2"/>
              <text x="30" y="38" fontSize="12" fill="#4285F4" textAnchor="middle" fontWeight="600">.png</text>
            </svg>
          </div>
          <div className="file-icon">
            <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
              <rect x="10" y="10" width="40" height="40" rx="4" fill="#E8F0FE" stroke="#4285F4" strokeWidth="2"/>
              <text x="30" y="38" fontSize="12" fill="#4285F4" textAnchor="middle" fontWeight="600">.jpg</text>
            </svg>
          </div>
        </div>
        <p className="drag-text">DRAG IMAGE HERE TO BEGIN</p>
      </div>

      <div className="upload-options">
        <span className="or-text">or you can</span>
        <label htmlFor="file-upload" className="upload-button">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{marginRight: '8px'}}>
            <path d="M10 3V17M3 10H17" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          </svg>
          PICK IMAGE TO VECTORIZE
          <input
            id="file-upload"
            type="file"
            accept="image/png,image/jpeg,image/jpg,image/gif"
            onChange={handleFileInput}
            style={{ display: 'none' }}
          />
        </label>
        <span className="or-text">or press</span>
        <div className="keyboard-shortcuts">
          <span className="key">CTRL</span>
          <span className="plus">+</span>
          <span className="key">V</span>
        </div>
      </div>
    </div>
  );
};

export default Home;
